export const LIST_PREPACKAGES = 'LIST_PREPACKAGES';
export const LIST_PREPACKAGES_LOADING = 'LIST_PREPACKAGES_LOADING';
export const CANCEL_PREPACKAGES_LOADING = 'CANCEL_PREPACKAGE_LOADING';
export const CANCEL_PREPACKAGE = 'CANCEL_PREPACKAGE';
export const GET_PREPACKAGE = 'GET_PREPACKAGE';
export const GET_PREPACKAGE_LOADING = 'GET_PREPACKAGE_LOADING';
export const UPDATE_PREPACKAGE = 'UPDATE_PREPACKAGE';
export const UPDATE_PREPACKAGE_LOADING = 'UPDATE_PREPACKAGE_LOADING';
